import { Select } from 'antd';
import React from 'react';

interface Props {
  df: string;
  id: any;
  name: string;
  registerAmazonAcc: string;
  //filter
  handleFilterValue: Function;
}
const { Option } = Select;

const DropdownFilter = ({
  handleFilterValue
}: Props) => {
  const handleChange = (value: { value: string; label: React.ReactNode }) => {
    handleFilterValue(value.value);
  };
  return (
    <Select
      labelInValue
      placeholder="선택"
      onChange={handleChange}
    >
      <Option value="">선택</Option>
      <Option value="email">아이디</Option>
      <Option value="name">이름</Option>
      <Option value="amazonSellerId">아마존 계정 등록</Option>
    </Select>
  );
};

export default DropdownFilter;
